export enum KeyIds {
  KNOWLEDGE = 'knowledge_id',
  TOPIC = 'topic_id',
  TAGS = 'tag_id',
  COMPANY_UNIT_ID = 'company_unit_id',
}
